module.exports = __webpack_public_path__ + "img/faq_account_delete.087dc892.svg";